import { render } from "./WebsiteBrand.vue?vue&type=template&id=78315ce6"
import script from "./WebsiteBrand.vue?vue&type=script&lang=js"
export * from "./WebsiteBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__